import { Outlet, useLocation } from 'react-router-dom';

import { Flex } from '@tradener/lumen';

import Header from '~/theme/layout/Header';

import CounterpartyHeaderTopFilters from './Dashboard/Detail/components/CounterpartyHeaderTopFilters';

function OperationLimitsLayout() {
  const location = useLocation();
  const isDashboardRoute = location.pathname.startsWith('/limits/dashboard');
  const isDashboardDetailRoute = /^\/limits\/dashboard\/[^/]+/.test(location.pathname);

  return (
    <Flex direction="column" width="full">
      <Header px="4" columnGap="3" align="center">
        {isDashboardRoute ? <CounterpartyHeaderTopFilters showCounterpartySearch={isDashboardDetailRoute} /> : null}
      </Header>
      <Outlet />
    </Flex>
  );
}

export default OperationLimitsLayout;
